import { EmptyStateTheme as EmptyStateThemeBase } from "@acin.reactjs/acin-ui/emptyState";
import { ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";

const EmptyStateTheme: ComponentCSSStyle<EmptyStateThemeBase> = {
  title: {
    fontSize: "16px",
    marginTop: "12px",
    fontWeight: 500,
  },
};

export default EmptyStateTheme;
